<div class="addtional-data-box">
  <ng-container *ngIf="isParsing()">
    <div class="addtional-data-box__item file-name">
      <div class="addtional-data-box__item__name">
        {{ "common.file" | translate }}:
      </div>
      <div class="addtional-data-box__item__value">
        {{ parsingFileName }}
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isPrinting() && deviceJob">
    <div class="addtional-data-box__item file-name">
      <div class="addtional-data-box__item__name">
        {{ "common.file" | translate }}:
      </div>
      <div class="addtional-data-box__item__value">
        {{ deviceJob.fileName }}
      </div>
    </div>
    <ng-container *ngFor="let material of deviceJob.materials">
      <div class="addtional-data-box__item">
        <div class="addtional-data-box__item__name">
          {{ "device.files.printing-material" | translate }}:
        </div>
        <div class="addtional-data-box__item__value">
          {{ material.name }}
        </div>
      </div>
      <div class="addtional-data-box__item">
        <div class="addtional-data-box__item__name">
          {{ "device.files.total-material" | translate }}:
        </div>
        <div class="addtional-data-box__item__value">
          {{ material.total | number : "1.0-3" }} {{ material.unit }}
        </div>
      </div>
      <div
        class="addtional-data-box__item">
        <div class="addtional-data-box__item__name">
          {{ "common.spools" | translate }}:
        </div>
        <div class="addtional-data-box__item__value">
          {{ material.spools.join(', ') }}
        </div>
      </div>
    </ng-container>
    <div class="addtional-data-box__item">
      <div class="addtional-data-box__item__name">
        {{ "device.details.profile" | translate }}:
      </div>
      <div
        class="addtional-data-box__item__value cursor-pointer"
        [nbPopover]="printProfileImage"
        nbPopoverTrigger="hover"
        nbPopoverPlacement="top"
      >
        {{ printProfileStrings[deviceJob.profile] | translate | uppercase }}
      </div>

      <ng-template #printProfileImage>
        <img [width]="100" [src]="GetPrintProfileImg" alt="Print profile" />
      </ng-template>
    </div>
    <div class="addtional-data-box__item">
      <div class="addtional-data-box__item__name">
        {{ "device.details.print-owner" | translate }}:
      </div>
      <div class="addtional-data-box__item__value">
        {{ deviceJob.userName | translate }}
      </div>
    </div>
    <div class="addtional-data-box__item">
      <div class="addtional-data-box__item__name">
        {{ "common.start-date" | translate }}:
      </div>
      <div class="addtional-data-box__item__value">
        {{ deviceJob.startDate | utcToLocaleDateTime : "dd.MM.yyyy HH:mm:ss" }}
        <span class="unit">(HH:MM:SS)</span>
      </div>
    </div>
    <div class="addtional-data-box__item">
      <div class="addtional-data-box__item__name">
        {{ "device.files.printing-time" | translate }}:
      </div>
      <div class="addtional-data-box__item__value">
        <span *ngIf="(deviceJob.totalPrintTime | secondsToDays) >= 1">
          {{ deviceJob.totalPrintTime | secondsToDays }}d
        </span>
        {{ deviceJob.totalPrintTime * 1000 | date : "HH:mm:ss" : "UTC" }}
        <span class="unit">(HH:MM:SS)</span>
      </div>
    </div>
    <div class="addtional-data-box__item">
      <div class="addtional-data-box__item__name">
        {{ "common.layer" | translate }}:
      </div>
      <div *ngIf="deviceJob.currentLayer > 0; else printingRaft">
        <div
          class="addtional-data-box__item__value"
          *ngIf="deviceJob.layersCount"
        >
          {{ deviceJob.currentLayer }}/{{ deviceJob.layersCount }}
          <nb-icon icon="layers-outline"></nb-icon>
        </div>
        <div
          class="addtional-data-box__item__value"
          *ngIf="!deviceJob.layersCount"
        >
          {{ deviceJob.currentLayer }} <nb-icon icon="layers-outline"></nb-icon>
        </div>
      </div>

      <ng-template #printingRaft>
        <div class="addtional-data-box__item__value">
          {{ "common.raft" | translate | titlecase }}
        </div>
      </ng-template>
    </div>
  </ng-container>
  <ng-container *ngIf="showMaterialData">
    <div
      class="addtional-data-box__item"
      *ngIf="deviceStatus.statusCode === statusTypes.failsafe"
    >
      <div class="addtional-data-box__item__name">
        {{ "common.reason" | translate }}:
      </div>
      <div class="addtional-data-box__item__value">
        {{ checkReasonContent() }}
      </div>
    </div>
    <!-- <div *ngFor="let material of deviceStatus.currentLoadedMaterials" class="addtional-data-box__item">
            <div class="addtional-data-box__item__name">
                {{'device.status.loaded-material' | translate}}:
            </div>
            <div class="addtional-data-box__item__value">
                {{material.name}} {{ material.unit }}
            </div>
        </div> -->
  </ng-container>
</div>
